import React from "react";

// The cookie illustration shared with the web client's consent sheet.
// Rendered bare — no container, no background — at its natural aspect ratio.
// The source is a wide canvas with transparent padding either side; that is
// intentional, so the mark is sized by height and left to find its own width.
const CookieMark = () => (
	<img
		src={"/cookie.png"}
		alt=""
		aria-hidden="true"
		className="h-12 w-auto flex-shrink-0"
	/>
);

export default CookieMark;
